import { z } from 'zod'
import { contactPhoneSchema, timestampSchema, uuidSchema } from './common.ts'

export const shipmentStatusSchema = z.enum([
  'draft',
  'loaded',
  'in_transit',
  'delivered',
  'cancelled',
])
export type ShipmentStatus = z.infer<typeof shipmentStatusSchema>

export const SHIPMENT_STATUSES = shipmentStatusSchema.options
export const SHIPMENT_STATUS_LABELS: Record<ShipmentStatus, string> = {
  draft: 'Чернетка',
  loaded: 'Завантажено',
  in_transit: 'У дорозі',
  delivered: 'Доставлено',
  cancelled: 'Скасовано',
}

const optionalText = (max: number) => z.string().trim().max(max).nullable().default(null)

const shipmentDetailsShape = {
  recipientName: z.string().trim().min(1).max(300),
  recipientPhone: contactPhoneSchema,
  recipientAddress: z.string().trim().min(1).max(1000),
  route: z.string().trim().max(1000).nullable(),
  carrier: z.string().trim().max(200).nullable(),
  trackingNumber: z.string().trim().max(200).nullable(),
  plannedDeliveryDate: z.iso.date().nullable(),
  status: shipmentStatusSchema,
}

export const createShipmentInputSchema = z.strictObject({
  ...shipmentDetailsShape,
  route: optionalText(1000),
  carrier: optionalText(200),
  trackingNumber: optionalText(200),
  plannedDeliveryDate: z.iso.date().nullable().default(null),
  status: shipmentStatusSchema.default('draft'),
  orderId: uuidSchema,
})
export type CreateShipmentInput = z.infer<typeof createShipmentInputSchema>

export const updateShipmentInputSchema = z
  .strictObject(shipmentDetailsShape)
  .partial()
  .superRefine((input, context) => {
    if (Object.keys(input).length === 0)
      context.addIssue({ code: 'custom', message: 'Передайте щонайменше одне поле' })
  })
export type UpdateShipmentInput = z.infer<typeof updateShipmentInputSchema>

export const shipmentListQuerySchema = z.strictObject({
  search: z.string().trim().max(200).optional(),
  status: shipmentStatusSchema.optional(),
})
export type ShipmentListQuery = z.infer<typeof shipmentListQuerySchema>

export const shipmentSchema = z.object({
  id: uuidSchema,
  orderId: uuidSchema,
  orderNumber: z.string(),
  orderProductName: z.string(),
  clientName: z.string(),
  recipientName: z.string(),
  recipientPhone: z.string(),
  recipientAddress: z.string(),
  route: z.string().nullable(),
  carrier: z.string().nullable(),
  trackingNumber: z.string().nullable(),
  plannedDeliveryDate: z.iso.date().nullable(),
  status: shipmentStatusSchema,
  createdBy: uuidSchema,
  updatedBy: uuidSchema,
  createdAt: timestampSchema,
  updatedAt: timestampSchema,
})
export type Shipment = z.infer<typeof shipmentSchema>

export const shipmentOrderOptionSchema = z.object({
  id: uuidSchema,
  number: z.string(),
  productName: z.string(),
  clientName: z.string(),
})
export type ShipmentOrderOption = z.infer<typeof shipmentOrderOptionSchema>
